import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaCheck } from 'react-icons/fa';
import { courses } from '../constants/courses';

const Courses = () => {
  const navigate = useNavigate();

  return (
    <div className="container-page">
      <div className="max-w-2xl">
        <span className="eyebrow">Our Courses</span>
        <h2 className="section-title">Practical skills, taught properly</h2>
        <p className="section-lead">
          Six focused programmes built around hands-on work, small groups and instructors who
          have done the job themselves.
        </p>
      </div>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {courses.map(({ id, title, Icon, description, features, level, duration }) => {
          const open = () => navigate(`/courses/${id}`);

          return (
            <article
              key={id}
              onClick={open}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  open();
                }
              }}
              role="button"
              tabIndex={0}
              aria-label={`View details for ${title}`}
              className="card card-hover group flex h-full cursor-pointer flex-col p-7"
            >
              <div className="mb-6 flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-surface-line bg-surface-base text-brand-400 transition-colors duration-200 group-hover:border-brand-500/50 group-hover:text-brand-300">
                  <Icon className="h-5 w-5" />
                </span>
                <span className="text-xs font-medium uppercase tracking-[0.14em] text-ink-faint">
                  {duration}
                </span>
              </div>

              <h3 className="text-lg font-semibold text-ink">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-muted">{description}</p>

              <ul className="mt-6 space-y-2.5">
                {features.map((feature) => (
                  <li key={feature} className="flex items-center text-sm text-ink-muted">
                    <FaCheck className="mr-3 h-3 w-3 flex-shrink-0 text-brand-500" />
                    {feature}
                  </li>
                ))}
              </ul>

              <div className="mt-auto pt-6">
                <div className="rule" />
                <div className="flex items-center justify-between pt-4">
                  <span className="text-sm text-ink-faint">{level}</span>
                  <span className="inline-flex items-center text-sm font-semibold text-brand-400 transition-colors group-hover:text-brand-300">
                    Details
                    <FaArrowRight className="ml-2 h-3 w-3 transition-transform duration-200 group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default Courses;
